import { useMemo } from 'react';
import dict from '../i18n/plans.json';
import { createT } from '../i18n/createT';

/** Traducteur de /plans. Les MONTANTS ne sont pas ici : ils vivent dans le
 *  composant, identiques dans les trois langues. */
export function usePlansT(language) {
  return useMemo(() => createT(dict, language), [language]);
}

export default usePlansT;
